"use client";

import { useEffect } from "react";
import type { Locale } from "@/lib/i18n";

/**
 * Non-critical stylesheets, injected after hydration so they never block the
 * first paint (Core Web Vitals LCP, 2026-10-10 audit):
 * - Font Awesome: only a handful of legacy service pages use its icons.
 * - Noto Serif SC: the Chinese display font, needed on /zh/ pages only.
 * Each link is added once; re-renders and route changes are no-ops.
 */
const FONT_AWESOME = "/fonts/fontawesome/css/all.min.css";
const NOTO_SERIF_SC =
  "https://fonts.googleapis.com/css2?family=Noto+Serif+SC:wght@500;700&display=swap";

function addStylesheet(href: string) {
  if (document.querySelector(`link[data-deferred="${href}"]`)) return;
  const link = document.createElement("link");
  link.rel = "stylesheet";
  link.href = href;
  link.dataset.deferred = href;
  document.head.appendChild(link);
}

export default function DeferredStyles({ locale }: { readonly locale: Locale }) {
  useEffect(() => {
    addStylesheet(FONT_AWESOME);
  }, []);

  useEffect(() => {
    if (locale === "zh") addStylesheet(NOTO_SERIF_SC);
  }, [locale]);

  return null;
}
